import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  root: {
    "&>p": {
      marginBottom: "50px",
    },
  },
  feature_text: {
    borderRadius: "6px",
    border: "1px solid #4D1277",
    //
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "16px",
    color: "#4D1277",
    background: "white",
    cursor: "pointer",
    textTransform: "capitalize",
    //
    width: "fit-content",
    alignSelf: "center",
    transitionDuration: ".2s",
    transitionProperty: "border,color,background-color",
    transitionTimingFunction: "cubic-bezier(.64,0,.35,1)",
    "&:hover": {
      backgroundColor: "#4d1277",
      color: "white",
    },
    marginTop: "20px",
  },
  rootHeaderBox: {
    position: "sticky",
    top: 0,
    backgroundColor: "#fff",
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    marginBottom: "20px",
  },
  rootBoxHeading: {
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "16px",
    color: "#272525",
  },
  rootBoxSubHeading: {
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "14px",
    color: "#999999",
  },
  videoHeader: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "10px",
  },
  rootContainer: {
    // height: "calc(100vh - 160px)",
    overflowY: "auto",
    //
    height: "calc(100vh - 170px)",
    [theme.breakpoints.down("md")]: {
      height: "calc(100vh - 240px)",
    },
  },
  planContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    marginTop: "20px",
  },
  planContentContainer: {
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
    gap: "20px",
    padding: "0 7px",
  },
  circularBox: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
}));

export default useStyles;
